"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonalInformationInit = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var cashLoanAuth_1 = require("../../model/cashLoanAuth");
var service_1 = require("../../../library/base/service");
var PersonalInformationInit = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(PersonalInformationInit, _super);
    function PersonalInformationInit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '现金贷个人信息初始化接口';
        _this.code = '101121';
        _this.desc = '现金贷个人信息初始化接口';
        _this.requestParams = new cashLoanAuth_1.PersonalInformationInitRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return PersonalInformationInit;
}(service_1.BaseService));
exports.PersonalInformationInit = PersonalInformationInit;
//# sourceMappingURL=personalInformationInit.js.map